import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../repositories/common/json_query';

export function trackBannerClick(jsonQuery: IJsonQuery): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Listing',
    label: 'nb_mortgage_banner',
    name: 'oldevent',
    sc: jsonQuery,
    useLastProducts: true,
  });
}

export function trackBannerShow(jsonQuery: IJsonQuery): void {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Listing',
    label: 'nb_mortgage_banner',
    name: 'oldevent',
    sc: jsonQuery,
    useLastProducts: true,
  });
}
